export default () => {
  const containers = document.querySelectorAll('.js-swatches')

  if (containers.length < 1) return
  ;[...containers].forEach(container => {
    const triggers = container.querySelectorAll('.js-swatches-trigger')
    console.log(triggers)
    const target = container.querySelector('.js-swatches-color')
    const defaultVal = target.innerHTML

    ;[...triggers].forEach(trigger => {
      trigger.addEventListener('mouseover', e => {
        target.innerHTML = trigger.dataset.target
      })

      trigger.addEventListener('mouseleave', e => {
        target.innerHTML = defaultVal
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Swatches.js